import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import { Card, CardImg, Row, Button ,CardBody,Col} from "reactstrap";
import { Select } from "react-inputs-validation";
import {updateSucursalSeleccionada} from "../../redux/actions/aRamos"
import Page from "components/Page";
import ImgExitoso from "assets/img/REJECTED.png";
import ImgProceso from "assets/img/enproceso.png";

class CardPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      Selectsucursales: this.props.usuarioSucursal,
      validate:false,
      hasSucursalError:false,
      mensaje:""
    };
    this.validateForm=this.validateForm.bind(this);
  }


  toggleValidating(validate) {
    this.setState({ validate });
  }
  validateForm(e) {
    e.preventDefault();
   
      this.props.history.push({
        pathname: "/",
      });
}

async componentDidMount(){
  const queryParams = new URLSearchParams(this.props.location.search);
  const Obtenermensaje=queryParams.get('mensaje');
  this.setState({ mensaje: Obtenermensaje});
}


  render() {
    const {  mensaje } = this.state;
    let tituloBread='Recuperar Cotización';
    if(mensaje !== undefined  && mensaje === "usuarioincorrectoCompra")
    {
      tituloBread='Recuperar Compra';
    }
    return (
      <Page title={tituloBread} breadcrumbs={[{ name: tituloBread, active: true }]}>
        <Card className="flex-row">
              <CardBody>
              {mensaje !== undefined  && mensaje === "usuarioincorrectoCompra" &&
                    <Row>
                    <Col lg={8} md={8} sm={8} xs={8}>
                      <div style={{ padding: "1em" }}>
                        <h2 style={{ color: "#001871" }}>No se ha Podido Recuperar tu Compra</h2>
                      </div>
                      <div style={{ padding: "1em",  textAlign:"justify" }}>
                        <h4> {`Tu compra no ha podido ser recuperada debido a que tu usuario no es el que la realizó. Para poder recuperar correctamente se debe cerrar la sesión actual, e iniciar sesión con el usuario que realizó la compra.`}.</h4>
                      </div>
                    </Col>
                    <Col
                      lg={4}
                      md={4}
                      sm={4}
                      xs={12}
                      style={{ textAlign: "center" }}
                    >
                      <img src={ImgExitoso} width="100px"></img>
                    </Col>
                  </Row>
              }

              {mensaje !== undefined  && mensaje === "usuarioincorrecto" &&
                    <Row>
                    <Col lg={8} md={8} sm={8} xs={8}>
                      <div style={{ padding: "1em" }}>
                        <h2 style={{ color: "#001871" }}>No se ha Podido Recuperar tu Cotización</h2>
                      </div>
                      <div style={{ padding: "1em",  textAlign:"justify" }}>
                        <h4> {`Tu cotización no ha podido ser recuperada debido a que tu usuario no es el que realizó la cotización. Para poder recuperar correctamente se debe cerrar la sesión actual, e iniciar sesión con el usuario que realizó la cotización`}.</h4>
                      </div>
                    </Col>
                    <Col
                      lg={4}
                      md={4}
                      sm={4}
                      xs={12}
                      style={{ textAlign: "center" }}
                    >
                      <img src={ImgExitoso} width="100px"></img>
                    </Col>
                  </Row>
              }

              {mensaje !== undefined  && mensaje === "formulariovinculacion" &&
                                <Row>
                                <Col lg={8} md={8} sm={8} xs={8}>
                                  <div style={{ padding: "1em" }}>
                                    <h2 style={{ color: "#001871" }}>Pendiente Formulario de Vinculación</h2>
                                  </div>
                                  <div style={{ padding: "1em", textAlign:"justify"}}>
                                    <h4> {`Al momento tu cotización se encuentra en proceso de completar Formulario de Vinculación. Una vez completado esto, el siguiente paso la Inspección, posterior a la Inspección podremos continuar con la emisión de la Póliza`}.</h4>                                  
                                  </div>
                                </Col>
                                <Col
                                  lg={4}
                                  md={4}
                                  sm={4}
                                  xs={12}
                                  style={{ textAlign: "center" }}
                                >
                                  <img src={ImgProceso} width="100px"></img>
                                </Col>
                              </Row>
                          }

                          {mensaje !== undefined  && mensaje === "inspeccion" &&
                                <Row>
                                <Col lg={8} md={8} sm={8} xs={8}>
                                  <div style={{ padding: "1em" }}>
                                    <h2 style={{ color: "#001871" }}>Pendiente Inspección</h2>
                                  </div>
                                  <div style={{ padding: "1em", textAlign:"justify" }}>
                                    <h4> {`Al momento tu cotización se encuentra en proceso de Inspección, posterior a la Inspección podremos continuar con la emisión de la Póliza`}.</h4>                                  
                                  </div>
                                </Col>
                                <Col
                                  lg={4}
                                  md={4}
                                  sm={4}
                                  xs={12}
                                  style={{ textAlign: "center" }}
                                >
                                  <img src={ImgProceso} width="100px"></img>
                                </Col>
                              </Row>
                          }
                
                <Row>
                  <Col lg={8} md={8} sm={8} xs={8}>
                      <div style={{ marginLeft: "1em" }}>
                        <Button className="btn btn-primary" onClick={this.validateForm}>
                        <i className="fa fa-chevron-circle-right" aria-hidden="true" /> IR Al INICIO
                        </Button>
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>
            <div style={{ padding: "26vh" }}></div>
      </Page>
    );
  }
}
const mapStateToProps = state => ({
  datosSucursales: state.datosSucursales,
});
const mapDispatchToProps = dispatch => {
  return {
    updateSucursalSelecionada: (SucursalSelecionada) => dispatch(updateSucursalSeleccionada(SucursalSelecionada)),
  };
};
export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(CardPage)
);
